module.exports = __webpack_public_path__ + "static/media/load.97f44750.gif";